import * as React from 'react';
import { useState, useEffect, ChangeEvent, useMemo, useRef, FocusEvent } from 'react';
import "./PostalCode.scss";

interface PostalCodeProps {
  name: string;
  value: string;
  placeholder?: string;
  onBlur: (e: FocusEvent<HTMLInputElement>) => void;
  onChangeValue: (e: ChangeEvent<HTMLInputElement>, v: string) => void;
  setTouched: (v: boolean) => void;
  setValue: (v: string) => void;
}

const PostalCode = (props: PostalCodeProps) => {
  const ref = useRef<HTMLInputElement>();
  const [value, setValue] = useState((props.value || "-").split("-"));
  const [composition, setComposition] = useState(false);
  
  useEffect(() => {
    if (ref?.current && /[0-9]/.test(value[0]) && value[0].length >= 3 && !composition) {
      ref.current.focus();
    }
  }, [composition, value[0], value[1]]);

  useEffect(() => {
    props.setValue(value.join("-"));
  }, [value]);

  const onchange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
    props.setTouched(true);
    if (index === 0) {
      setValue([ e.target.value || "", value[1] || "" ]);
    } else if (index === 1) {
      setValue([ value[0] || "", e.target.value || "" ]);
    }
  }

  const placeholder = useMemo(() => {
    if (!props.placeholder) return ["", ""];
    const _placeholder = props.placeholder.split("-");
    if (_placeholder.length < 2) return [_placeholder[0], ""];
    return _placeholder;
  }, [props.placeholder]);

  return (
    <div className="postal-code">
      <input
        name={props.name ? props.name + "1" : undefined}
        placeholder={!placeholder ? "" : placeholder[0]}
        type="text" inputMode="numeric" pattern="\d*"
        className="head" maxLength={3} value={value[0] || ""}
        onBlur={props.onBlur}
        onChange={e => onchange(e, 0)}
        onCompositionStart={_ => setComposition(true)}
        onCompositionEnd={_ => setComposition(false)}
      />
      <input
        name={props.name ? props.name + "2" : undefined}
        placeholder={!placeholder ? "" : placeholder[1]}
        ref={ref} type="text" inputMode="numeric" pattern="\d*"
        className="tail" maxLength={4} value={value[1] || ""}
        onBlur={props.onBlur}
        onChange={e => onchange(e, 1)}
      />
    </div>
  );
}

export default PostalCode;